import React, { Component } from "react";
import classnames from "classnames";

import "./InputField.css";

import DisplayError from "../DisplayError/DisplayError";
import wrapperComponent from "../WrapperComponent/WrapperComponent";
import Tooltip from '../Tooltip';

class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      showTooltip: false,
      randomIdx: Math.random().toString(36).slice(2),
      isHidden: true,
      type: this.props.type || 'text'
    };
    this.deleteSupplier = this.deleteSupplier.bind(this)
  }
  static getClassName() { return 'InputField' };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value && this.props.value !== nextProps.value) {
      if (typeof nextProps.name === "string" && (nextProps.name.includes("workEmailAddress") || nextProps.name.includes("workTelephoneNumber"))) {
        this.validateInput(nextProps.value)
      }
    }
  }

  validateInput = (value) => {
    let _maxLength = this.props.maxLength ? (this.props.maxLength) - (this.props.countPrefix ? this.props.inputPrefix.length : 0) : this.props.maxLength;
    if (value.trim() !== "" || value.length === 0) {
      let actualValue = this.props.countPrefix ? `${this.props.inputPrefix}${value}` : `${value}`;
      if (_maxLength && actualValue.length > _maxLength) {
        actualValue = actualValue.slice(0, this.props.maxLength)
      }
      if (this.state.errorString.trim() !== "") {
        this.setState({
          errorString: ""
        });
      }
    }
  }

  handleChange = e => {
    let _maxLength = this.props.maxLength ? (this.props.maxLength) - (this.props.countPrefix ? this.props.inputPrefix.length : 0) : this.props.maxLength;
    if (e.target.value.trim() !== "" || e.target.value.length === 0) {
      let actualValue = this.props.countPrefix ? `${this.props.inputPrefix}${e.target.value}` : `${e.target.value}`;
      if (_maxLength && actualValue.length > _maxLength) {
        actualValue = actualValue.slice(0, this.props.maxLength)
      }
      this.props.onEdit({ type: 'inputFieldChangeOperation', value: actualValue, idx: this.props.repeatComponentIdx });
      if (this.state.errorString.trim() !== "") {
        this.setState({
          errorString: ""
        });
      }
    }
  };

  //to handle keypress for number type input in IE
  handleKeyPress = (e) => {
    let newValue = e.target.value + e.key;
    if (
      //If the input type id number
      this.state.type === 'number' &&
      // It is not a number nor a control key?
      isNaN(newValue) &&
      e.which != 8 && // backspace
      e.which != 17 && // ctrl
      newValue[0] != '-' || // minus
      // It is not a negative value?
      newValue[0] == '-' &&
      isNaN(newValue.slice(1)))
      e.preventDefault();
  }

  handleBlur = e => {
    const { target } = e
    if ((!this.props.value || this.props.value.trim() === "") && this.props.required) {
      this.setState({
        errorString: this.props.customErrorMessage
      });
    }
    else if (this.props.regex && this.props.regexValidationMessage && (typeof target.value === "string" && target.value.trim() !== "")) {
      if (!new RegExp(this.props.regex).test(target.value)) {
        this.setState({
          errorString: this.props.regexValidationMessage
        });
      }
    }
  };

  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.props.name + this.state.randomIdx}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.props.name + this.state.randomIdx}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  togglePasswordVisiblity = () => {
    this.setState({
      type: !this.state.isHidden ? this.props.type : 'text',
      isHidden: !this.state.isHidden
    })
  }

  togglePasswordVisiblityOnKeyPress = (event) => {
    if (event.key === "Enter") {
      this.setState({
        type: !this.state.isHidden ? this.props.type : 'text',
        isHidden: !this.state.isHidden
      })
    }
  }

  deleteSupplier(field) {
    if (field !== undefined) {
      this.props.deleteSupplier(field)
    }
  }

  render() {
    const inputDisplayStyle = classnames("input-field-content", { "input-field-content-disabled": this.props.disabled });
    const inputLabelClass = classnames({
      "input-field-label-div": this.props.repeatingField === false ? true : false,
      "input-field-embedded-label-div": this.props.repeatingField === true ? true : false,
    })
    return (
      <div className="input-field-main-div" id={this.props.name + this.state.randomIdx}>
        {this.props.label ? (
          <div className={inputLabelClass}>
            <label htmlFor={this.props.name + "_" + this.state.randomIdx}>
              {this.props.label}
            </label>
            {this.props.helpText &&
              <div>
                {this.props.helpText}
              </div>
            }
          </div>
        ) : (
          <div className={inputLabelClass}>
          </div>
        )}
        {this.props.inputPrefix ? (
          <span className={classnames("input-field-prefix", { "h29rem": this.state.errorString && this.state.errorString.trim() !== "" })}>
            {this.props.inputPrefix}
          </span>
        ) : ('')
        }
        <div className="input-field-content-div">
          <input
            className={inputDisplayStyle}
            value={this.props.value}
            onChange={this.handleChange}
            maxLength={this.props.maxLength ? ((this.props.maxLength) - (this.props.countPrefix ? this.props.inputPrefix.length : 0)) : undefined}
            minLength={this.props.minLength}
            onBlur={this.handleBlur}
            type={this.state.type}
            required={this.props.required}
            disabled={this.props.disabled}
            onKeyPress={this.handleKeyPress}
            autoComplete="new-password"
            id={this.props.name + "_" + this.state.randomIdx}
          />
          {this.props.helperText ? (
            <p style={{ margin: "0px" }}>{this.props.helperText}</p>
          ) : (
            ""
          )}
          {this.state.errorString && this.state.errorString.trim() !== "" ? (
            <DisplayError color="red" errorText={this.state.errorString} />
          ) : (
            ""
          )}
          {this.props.type === 'password' ? (
            <span
              onClick={this.togglePasswordVisiblity} title={this.state.isHidden ? 'Show password' : 'Hide password'}
              onKeyDown={(event) => this.togglePasswordVisiblityOnKeyPress(event)}
              className="gdocs-input-password-visiblity-div"
              role="button"
              tabindex="0"
              aria-label={this.state.isHidden ? 'Show password' : 'Hide password'}
            >
              {this.state.isHidden ? (<i className="icon icon-do-not-view gdocs-valign-middle gdocs-mleft-5 hintText-icon"></i>)
                : (<i className="icon icon-view gdocs-valign-middle gdocs-mleft-5 hintText-icon"></i>)
              }
            </span>
          ) : ('')}
        </div>
        {this.props.tooltip ? (
          <div style={{ display: "inline-block" }}>
            <button type="button" data-toggletip-content={this.props.tooltip}
              className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
              data-tooltip={this.props.name + this.state.randomIdx}
              aria-expanded={false}
              onMouseEnter={this.toggleTooltip}
              onMouseLeave={this.toggleTooltip}
              onClick={this.toggleTooltip}
              onKeyUp={(event) => this.toggleTooltiponEnter(event)}
              aria-label={`Additional Information on ${this.props.label}`}
              aria-describedby={`${this.props.name + this.state.randomIdx}tooltip`}
            >
            </button>
            <Tooltip
              active={this.state.showTooltip}
              position="right"
              arrow="center"
              parent={this.props.name + this.state.randomIdx}
              parentClass="input-field-main-div"
            >
              <div className="tooltip-content-hintText"  >
                <span role="status" id={`${this.props.name + this.state.randomIdx}tooltip`}>{this.props.tooltip}</span>
              </div>
            </Tooltip>
          </div>
        ) : ('')
        }
        {this.props.isDeleteIcon === 'true' ? (
          <span onClick={(e) => this.deleteSupplier(this.props.name)}>
            <i
              className="icon icon-bin deleteIcon"
            >
            </i>
          </span>
        ) : ('')
        }
      </div>
    );
  }
}

const WrappedInputField = wrapperComponent(InputField);
export default WrappedInputField;



// WEBPACK FOOTER //
// ./src/components/common/InputField/InputField.js